module.exports = __webpack_public_path__ + "img/train-grey.f50bbf08.svg";